import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {GetSalesProcessContext as GetSalesProcessContextQuery} from 'nutshell-graphql-types';

import {generateContextString} from '../../helpers';

import GET_SALES_PROCESS_CONTEXT from '../queries/get-sales-process-context.graphql';

export const useGetSalesProcessContext = (): {
    context: string | null | undefined;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<GetSalesProcessContextQuery, Record<any, any>>(
        GET_SALES_PROCESS_CONTEXT,
        {}
    );

    return {
        context: generateContextString(data),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
